<template>
    <div>
        <span :class="showKeyboard ? 'active' : ''" class="pm-price-input-value" @click="(event) => activate(event)">{{ formattedPrice }}</span>

        <div @click="(event) => clickOutside(event)" v-if="showClickTrap" style="s-pointer-events: none; z-index: 9; position: fixed; left: 0; top: 0; right: 0; bottom: 0; background: rgba(255,255,255,0);" />

        <transition :name="keyboardShown ? '' : 'pm-fade-in-slide-up-transition'">
            <pm-numeric-keyboard maxLength="9" v-if="showKeyboard" :value="value" @input="onInput" @close="closeKeyboard"/>
        </transition>
    </div>
</template>

<style>
    .pm-price-input-value {
        line-height: 39px;
        margin-top: 12px;
        display: inline-block;
        border-bottom: 2px solid #949494;
        text-align: right;
        width: 90px;
        max-width: 90px;
        margin-left: 12px;
        position: relative;
    }

    .pm-price-input-value.active {
        border-bottom: 2px solid blue;
        color: blue;
        font-weight: 600;
        padding-right: 3px;
    }
    .pm-price-input-value.active:after {
        position: absolute;
        content: "";
        right: 0;
        top: 10px;
        width: 2px;
        background: blue;
        height: 20px;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
  50% {
    opacity: 1;
  }
}
</style>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: () => 0,
            required: true,
        }
    },
    data: () => ({
        showKeyboard: false,
        showClickTrap: false,
        keyboardShown: window.isPmNumericKeyboardShown === true,
    }),
    methods: {
        closeKeyboard() {
            this.showClickTrap = false;
            this.showKeyboard = false;
        },
        clickOutside(event) {
            this.showClickTrap = false;
            this.$nextTick(() => {
                const el = document.elementFromPoint(event.clientX, event.clientY);
                if (!el.classList.contains('pm-price-input-value')) window.isPmNumericKeyboardShown = false;
                this.showKeyboard = false;
                el.click();
            });
        },
        onInput(value) {
            this.$emit('input', parseInt(value));
        },
        activate(event) {
            if (this.showKeyboard) return;
            this.keyboardShown = window.isPmNumericKeyboardShown;
            this.showClickTrap = true;
            /*const el = document.getElementById('main-scrollable-content');
            const pos = el.scrollTop;
            const rect = event.target.getBoundingClientRect();

            el.scroll({
                top: pos + rect.top - 60,
                behavior: "smooth"
            });*/

            this.showKeyboard = true;
            window.isPmNumericKeyboardShown = true;
            this.$emit('click');
        },
    }
};
</script>
